import { jsx as _jsx } from "react/jsx-runtime";
import { Grid, Chart, BaggageChecked, Partners, Calendar, DeviceMobile, Passengers, Passenger, Close, ChevronLeft, Edit, CheckCircle, InformationCircle, QuestionCircle, Document, AccountCircle, Lock, LockOpen, Settings as SystemSettings, } from '@kiwicom/orbit-components/lib/icons';
import assessment_24px from '../../images/menu_icons/assessment_24px.png';
import palette_24px from '../../images/menu_icons/palette_24px.png';
import extension_24px from '../../images/menu_icons/extension_24px.png';
import palette_24px_1 from '../../images/menu_icons/palette_24px_1.png';
import account_multiple from '../../images/menu_icons/account_multiple.png';
import insert_drive_file_24px from '../../images/menu_icons/insert_drive_file_24px.png';
import notifications_active_24px from '../../images/menu_icons/notifications_active_24px.png';
import notificationPushWhite from '../../images/menu_icons/notificationPushWhite.png';
import Vector from '../../images/menu_icons/Vector.png';
import create_24px from '../../images/menu_icons/create_24px.png';
import settings_24px from '../../images/menu_icons/settings_24px.png';
import mdi_database_edit_2 from '../../images/menu_icons/mdi_database_edit_2.png';
import Group_603 from '../../images/menu_icons/Group_603.png';
import mdi_database_edit from '../../images/menu_icons/mdi_database_edit.png';
import mdi_database_edit_1 from '../../images/menu_icons/mdi_database_edit_1.png';
import Group_675 from '../../images/menu_icons/Group_675.png';
import Group_674 from '../../images/menu_icons/Group_674.png';
import vector_4 from '../../images/menu_icons/vector_4.png';
import vector_1 from '../../images/menu_icons/vector_1.png';
import vector_2 from '../../images/menu_icons/vector_2.png';
import vector_6 from '../../images/menu_icons/vector_6.png';
import vector_7 from '../../images/menu_icons/vector_7.png';
import appspotrStudioLogo from '../../images/appspotr_studios_symbol.png';
var IconsMap = {
    Grid: Grid,
    Chart: Chart,
    Organizations: BaggageChecked,
    Partners: Partners,
    Calendar: Calendar,
    DeviceMobile: DeviceMobile,
    Passengers: Passengers,
    Passenger: Passenger,
    Close: Close,
    ChevronLeft: ChevronLeft,
    Edit: Edit,
    CheckCircle: CheckCircle,
    InformationCircle: InformationCircle,
    QuestionCircle: QuestionCircle,
    Document: Document,
    AccountCircle: AccountCircle,
    Lock: Lock,
    LockOpen: LockOpen,
    SystemSettings: SystemSettings,
    AppOverview: (function () { return (_jsx("img", { src: assessment_24px, alt: "", width: "24px", height: "auto" })); }),
    Develope: (function () { return (_jsx("img", { src: extension_24px, alt: "", width: "24px", height: "auto" })); }),
    Data: (function () { return (_jsx("img", { src: palette_24px, alt: "", width: "24px", height: "auto" })); }),
    Design: (function () { return (_jsx("img", { src: palette_24px_1, alt: "", width: "24px", height: "auto" })); }),
    AppUsers: (function () { return (_jsx("img", { src: account_multiple, alt: "", width: "24px", height: "auto" })); }),
    Publish: (function () { return (_jsx("img", { src: insert_drive_file_24px, alt: "", width: "24px", height: "auto" })); }),
    PushNotifications: (function () { return (_jsx("img", { src: notifications_active_24px, alt: "", width: "24px", height: "auto" })); }),
    PushNotifications_white: (function () { return (_jsx("img", { src: notificationPushWhite, alt: "", width: "24px", height: "auto" })); }),
    Media: (function () { return _jsx("img", { src: Vector, alt: "", width: "24px", height: "auto" }); }),
    Admins: (function () { return (_jsx("img", { src: create_24px, alt: "", width: "24px", height: "auto" })); }),
    Settings: (function () { return (_jsx("img", { src: settings_24px, alt: "", width: "24px", height: "auto" })); }),
    AppDataSets: (function () { return (_jsx("img", { src: mdi_database_edit_2, alt: "", width: "24px", height: "auto" })); }),
    Patchwork: (function () { return (_jsx("img", { src: Group_603, alt: "", width: "24px", height: "auto" })); }),
    Views: (function () { return (_jsx("img", { src: mdi_database_edit, alt: "", width: "24px", height: "auto" })); }),
    Style: (function () { return (_jsx("img", { src: mdi_database_edit_1, alt: "", width: "24px", height: "auto" })); }),
    Users: (function () { return (_jsx("img", { src: Group_675, alt: "", width: "24px", height: "auto" })); }),
    Groups: (function () { return (_jsx("img", { src: Group_674, alt: "", width: "24px", height: "auto" })); }),
    Preferences: (function () { return (_jsx("img", { src: vector_4, alt: "", width: "24px", height: "auto" })); }),
    DataAndPrivacy: (function () { return (_jsx("img", { src: vector_1, alt: "", width: "24px", height: "auto" })); }),
    PurchaseLicense: (function () { return (_jsx("img", { src: vector_1, alt: "", height: "35px", width: "35px", style: {
            backgroundColor: 'white',
            borderRadius: 13,
            padding: 5,
            height: 35,
            width: 35,
        } })); }),
    SignOut: (function () { return (_jsx("img", { src: vector_2, alt: "", width: "24px", height: "auto" })); }),
    Distribution: (function () { return (_jsx("img", { src: vector_6, alt: "", width: "24px", height: "auto" })); }),
    Draft: (function () { return (_jsx("img", { src: vector_7, alt: "", width: "22px", height: "auto" })); }),
    AppspotrStudiosLogo: (function () { return (_jsx("img", { src: appspotrStudioLogo, alt: "", width: "16px", height: "16px" })); }),
};
var AvailableIcons;
(function (AvailableIcons) {
    AvailableIcons["Grid"] = "Grid";
    AvailableIcons["Chart"] = "Chart";
    AvailableIcons["Organizations"] = "Organizations";
    AvailableIcons["Partners"] = "Partners";
    AvailableIcons["AppOverview"] = "AppOverview";
    AvailableIcons["Develope"] = "Develope";
    AvailableIcons["Data"] = "Data";
    AvailableIcons["Design"] = "Design";
    AvailableIcons["AppUsers"] = "AppUsers";
    AvailableIcons["Publish"] = "Publish";
    AvailableIcons["PushNotifications"] = "PushNotifications";
    AvailableIcons["PushNotifications_white"] = "PushNotifications_white";
    AvailableIcons["Media"] = "Media";
    AvailableIcons["Admins"] = "Admins";
    AvailableIcons["Settings"] = "Settings";
    AvailableIcons["AppDataSets"] = "AppDataSets";
    AvailableIcons["Patchwork"] = "Patchwork";
    AvailableIcons["Views"] = "Views";
    AvailableIcons["Style"] = "Style";
    AvailableIcons["Users"] = "Users";
    AvailableIcons["Groups"] = "Groups";
    AvailableIcons["Preferences"] = "Preferences";
    AvailableIcons["DataAndPrivacy"] = "DataAndPrivacy";
    AvailableIcons["PurchaseLicense"] = "PurchaseLicense";
    AvailableIcons["SignOut"] = "SignOut";
    AvailableIcons["Calendar"] = "Calendar";
    AvailableIcons["DeviceMobile"] = "DeviceMobile";
    AvailableIcons["Passengers"] = "Passengers";
    AvailableIcons["Passenger"] = "Passenger";
    AvailableIcons["Close"] = "Close";
    AvailableIcons["ChevronLeft"] = "ChevronLeft";
    AvailableIcons["Distribution"] = "Distribution";
    AvailableIcons["Draft"] = "Draft";
    AvailableIcons["Edit"] = "Edit";
    AvailableIcons["CheckCircle"] = "CheckCircle";
    AvailableIcons["InformationCircle"] = "InformationCircle";
    AvailableIcons["QuestionCircle"] = "QuestionCircle";
    AvailableIcons["Document"] = "Document";
    AvailableIcons["AccountCircle"] = "AccountCircle";
    AvailableIcons["Lock"] = "Lock";
    AvailableIcons["LockOpen"] = "LockOpen";
    AvailableIcons["SystemSettings"] = "SystemSettings";
    AvailableIcons["AppspotrStudiosLogo"] = "AppspotrStudiosLogo";
})(AvailableIcons || (AvailableIcons = {}));
function Icon(props) {
    var IconX = IconsMap[props.name];
    return (_jsx(IconX, { size: props.size, customColor: props.customColor ? props.customColor : '#00000' }));
}
export { IconsMap, AvailableIcons, Icon };
